import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEyeOff20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconEyeOff20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m5.386 15.815-.867.867a.75.75 0 1 1-1.061-1.06L15.532 3.546a.75.75 0 0 1 1.06 1.061l-.729.73c1.402 1.247 2.352 2.723 2.886 3.7a2.23 2.23 0 0 1 0 2.153c-1.087 1.989-3.893 6.038-8.724 6.038-1.832 0-3.373-.582-4.64-1.414M14.8 6.4c1.23 1.073 2.102 2.388 2.632 3.358a.73.73 0 0 1 0 .714c-1.06 1.937-3.484 5.257-7.408 5.257-1.362 0-2.544-.4-3.55-1.003l1.337-1.337a3.952 3.952 0 0 0 5.487-5.487zm-2.595 2.594-3.301 3.302q.228.117.486.187a2.452 2.452 0 0 0 2.815-3.489m-9.588 1.478c.38.696.937 1.57 1.675 2.405l-1.061 1.061a14.8 14.8 0 0 1-1.93-2.747 2.23 2.23 0 0 1 0-2.153C2.387 7.05 5.193 3 10.024 3c1.276 0 2.411.283 3.41.735L12.28 4.889a6.7 6.7 0 0 0-2.256-.389C6.1 4.5 3.676 7.82 2.617 9.758a.73.73 0 0 0 0 .714"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEyeOff20);
